import $ from 'jquery';
import validate from 'jquery-validation'
window.$ = $;

import 'inputmask/dist/jquery.inputmask.bundle.js';
import 'owl.carousel/dist/owl.carousel.js';

import './app.js'
import './form.js'
import './select'
import './vkRetargeting.js'
